// @ vendors
const React = require('react');
const { cloneDeep } = require('lodash');

// @ components
const { InputSafe } = require('commonsComponents/inputSafe');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @constants
const { text } = require('../initialValues');

const inputSafe = (registralData, { label, name }) => {
    const textValue = text();
    return (
        <InputSafe
            label={textValue.LABEL[label]}
            name={name}
            type="text"
            value={registralData.data.fields[name]}
            onChange={evt => registralData.onChange(name, evt.target.value)}
            errorMessage={textValue.MESSAGES.REQUIRED}
            errorState={registralData.data.validation[name]}
        />
    );
}

const okSelect = (registralData, { options, label, name }) => {
    const textValue = text();
    return (
        <OKSelect
            label={textValue.LABEL[label]}
            name={name}
            options={options}
            value={registralData.data.fields[name].value}
            onChange={dataObject => registralData.onChange(name, dataObject)}
            errorMessage={textValue.MESSAGES.REQUIRED}
            errorState={registralData.data.validation[name]}
            searchable
        />
    )
};


const config = {
    province: {
        options: [],
        label: 'PROVINCE',
        name: 'province',
    },
    population: {
        options: [],
        label: 'POPULATION',
        name: 'population',
    },
    registerName: {
        options: [],
        label: 'REGISTER_NAME',
        name: 'registerName',
    },
    estateNumber: {
        label: 'ESTATE_NUMBER',
        name: 'estateNumber',
    },
    estateSection: {
        label: 'SECTION',
        name: 'estateSection',
    },
    estateBook: {
        label: 'BOOK',
        name: 'estateBook',
    },
    estateVolume: {
        label: 'VOLUME',
        name: 'estateVolume',
    },
    estateFolio: {
        label: 'FOLIO',
        name: 'estateFolio',
    },
};

const registralData = (registralData) => {
    const config_ = cloneDeep(config);
    config_.province.options = registralData.provinces;
    config_.population.options = registralData.population;
    config_.registerName.options = registralData.registers;

    return (
        <div className="col-xs-12">
            <div className="row">
                <div className="col-xs-4 registral-data__input">
                    {okSelect(registralData, config_.province)}
                </div>
                <div className="col-xs-4 registral-data__input">
                    {okSelect(registralData, config_.population)}
                </div>
                <div className="col-xs-4 registral-data__input">
                    {okSelect(registralData, config_.registerName)}
                </div>
            </div>
            <div className="row">
                <div className="col-xs-4 registral-data__input">
                    {inputSafe(registralData, config_.estateNumber)}
                </div>
                <div className="col-xs-2 registral-data__input">
                    {inputSafe(registralData, config_.estateSection)}
                </div>
                <div className="col-xs-2 registral-data__input">
                    {inputSafe(registralData, config_.estateBook)}
                </div>
                <div className="col-xs-2 registral-data__input">
                    {inputSafe(registralData, config_.estateVolume)}
                </div>
                <div className="col-xs-2 registral-data__input">
                    {inputSafe(registralData, config_.estateFolio)}
                </div>
            </div>
        </div>
    )
};

module.exports = registralData;
